import { render, staticRenderFns } from "./r-boat-order-dialog.vue?vue&type=template&id=3f968ddc&scoped=true"
import script from "./r-boat-order-dialog.vue?vue&type=script&lang=js"
export * from "./r-boat-order-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-boat-order-dialog.vue?vue&type=style&index=0&id=3f968ddc&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f968ddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f968ddc')) {
      api.createRecord('3f968ddc', component.options)
    } else {
      api.reload('3f968ddc', component.options)
    }
    module.hot.accept("./r-boat-order-dialog.vue?vue&type=template&id=3f968ddc&scoped=true", function () {
      api.rerender('3f968ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-order-dialog.vue"
export default component.exports